module.exports = __webpack_public_path__ + "img/face-kiss-beam.8f51ed10.svg";